// (bnikom) code based off of https://github.com/emilebres/react-virtualized-checkbox

import React, { Component, Fragment } from 'react';
import { Input, Label } from 'reactstrap';
import { FixedSizeGrid as Grid } from 'react-window';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Checkbox = ({ onChange, onClick, checked, label, style, src }) => (
  <div style={{ ...style }} className="px-2">
    <button
      className={`${checked ? 'border-green' : 'border'} w-100 p-2 bg-white`}
      onClick={() => onClick(label, checked)}
      type="button"
    >
      <div className="h-100">
        <p className="text-left">
          <Label check>
            <Input
              className="m-0 position-relative"
              type="checkbox"
              value={label}
              checked={checked}
              aria-label="Photo Checkbox"
              onChange={onChange}
            />
          </Label>
          &nbsp; Lot {label}
        </p>
        {checked && (
          <FontAwesomeIcon icon="check-circle" className="color-success check-photo" size="3x" />
        )}
        <div className="cover-photo-container d-flex justify-content-center align-items-center">
          <img
            className="mw-100 mh-100"
            src={src}
            // TODO: (bnikom) does this need to be a lot num or lot title?????
            alt={`Lot ${label}`}
          />
        </div>
      </div>
    </button>
  </div>
);

class Checkboxes extends Component {
  componentDidUpdate() {
    // (bnikom) https://reactjs.org/docs/react-component.html#forceupdate
    this.list.forceUpdate();
  }

  handleClick = (label, checked) => {
    const { labelKey, onChange } = this.props;
    onChange({ [labelKey]: label, checked: !checked });
  };

  handleChange = event => {
    const { labelKey, onChange } = this.props;
    onChange({ [labelKey]: event.target.value, checked: event.target.checked });
  };

  checkboxRenderer = ({ columnIndex, rowIndex, style }) => {
    const { columnCount, items, labelKey } = this.props;
    const index = columnIndex + columnCount * rowIndex;
    const item = items[index];

    return (
      <Fragment>
        {/* to account for ending on an incomplete row */}
        {index <= items.length - 1 && (
          <Checkbox
            style={style}
            key={item[labelKey]}
            onChange={this.handleChange}
            onClick={this.handleClick}
            label={item[labelKey]}
            checked={item.checked}
            src={item.src}
          />
        )}
      </Fragment>
    );
  };

  render() {
    const { columnCount, columnWidth, height, items, rowHeight, width } = this.props;

    return (
      <Grid
        columnCount={columnCount}
        columnWidth={columnWidth}
        height={height}
        rowCount={Math.ceil((items.length + 1) / 4)}
        rowHeight={rowHeight}
        width={width}
        ref={ref => {
          this.list = ref;
        }}
      >
        {this.checkboxRenderer}
      </Grid>
    );
  }
}

export default Checkboxes;
